<template>
  <div class="price-adj-group">
    <b-form-group>
      <base-input
      :name="name"
      type="text"
      classInput="rounded"
      :placeholder="$t('price-adj.input.placeholder')"
      :value="value"
      @input="updateInput"
      @change="updateInput"
      :validations="[
        {
          condition: parentErrors.has(name),
          text: parentErrors.first(name)
        }
      ]"
      >
      </base-input>
      <div class="wrapp-price-mode">
        <button
        class="btn btn-icon btn-icon-xsmall btn-rounded"
        v-for="(layout, index) in listLayout"
        :key="index"
        v-html="layout.icon"
        :class="{ 'active': index === activeLayoutIndex }"
        @click.prevent="setCurrentLayout(index)"></button>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import BaseInput from 'theme/components/Form/BaseInput'

export default {
  name: 'PriceInput',
  $_veeValidate: {
    value () {
      return this.value
    },
    name () {
      return this.name
    }
  },
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    discountType: {
      type: String,
      default: 'percentage'
    },
    parentErrors: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      priceValue: '',
      activeLayoutIndex: 0,
      listLayout: [
        {
          name: 'percentage',
          icon: '%'
        },
        {
          name: 'amount',
          icon: '€'
        }
      ]
    }
  },
  methods: {
    setCurrentLayout (index = null) {
      let layoutIndex = 1
      if (index !== null) {
        layoutIndex = index
      }
      this.activeLayoutIndex = layoutIndex
      this.$emit('update:discountType', this.listLayout[layoutIndex].name)
    },
    updateInput ($event) {
      this.$emit('input', $event)
    }
  },
  components: {
    BaseInput
  }
}
</script>
